
<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item">
                <router-link to="/purchase/vendors">{{ $t('vendor_list') }}</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">{{ title }}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button>
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="clickSaveHandler">
                <i class="fa fa-floppy-o"></i>
                {{ $t('save') }}
            </button>
        </div>
        <div class="x_body">
            <div class="card x_card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-6">
                            <div class="form-group">
                                <label class="label-control blue">{{ $t('vendor_type') }}</label>
                            <div>
                                <select class="form-control form-control-sm" v-model="model.VendorTypeId">
                                    <option v-for="ret in types" :key="ret.Id" :value="ret.Id">{{ret.Name}}</option>
                                </select>
                            </div>
                        </div>                        
                        </div>                                                                        
                    </div>
                    <div class="row">
                        <div class="col-sm-6">
                            <div class="form-group" :class="{ 'form-group-error': $v.model.NameEng.$error }">
                                <label class="label-control blue">{{ $t('latin_name')}}</label>
                                <div><input class="form-control form-control-sm" type="text" v-model="$v.model.NameEng.$model" /></div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6">
                            <div class="form-group" :class="{ 'form-group-error': $v.model.Name.$error }">
                                <label class="label-control blue">{{ $t('khmer_name')}}</label>
                                <div><input class="form-control form-control-sm" type="text" v-model="$v.model.Name.$model" /></div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6">
                            <div class="form-group">
                                <label class="label-control blue">{{ $t('display_name')}}</label>
                                <div><input class="form-control form-control-sm" type="text" v-model="model.DisplayName" /></div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6">                            
                            <div class="form-group" :class="{ 'form-group-error': $v.model.VatTin.$error }">
                                <label class="label-control blue">{{ $t('VatTin')}}</label>
                                <b-form-input class="form-control-sm" v-model="$v.model.VatTin.$model" />
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-3">
                            <div class="form-group">
                                <label class="label-control blue">{{ $t('work_phone')}}</label>
                                <div>
                                    <input class="form-control form-control-sm" type="text" v-model="model.WorkPhone" />
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-3">
                            <div class="form-group">
                                <label class="label-control blue">{{ $t('mobile_phone') }}</label>
                                <div>
                                    <input class="form-control  form-control-sm" type="email" v-model="model.Phone" />
                                </div>
                            </div>
                        </div>
                    </div>                    
                    <div class="row">
                        <div class="col-sm-6">
                            <div class="form-group" :class="{ 'form-group-error': $v.model.Address.$error }">
                                <label class="label-control blue">{{ $t('billing_address') }}</label>
                                <div>
                                    <input class="form-control form-control-sm" type="text" v-model="$v.model.Address.$model" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { required, requiredIf } from 'vuelidate/lib/validators'
    export default {
        props: ['module'],
        data: function () {
            return {
                model: {
                    Name: "",
                    DisplayName: "",
                    WorkPhone: "",
                    Phone: "",
                    VatTin: "",
                    VendorTypeId: null,
                    Address: "",
                    NameEng: ""
                },
                capitals: [],
                actionLink: 'vendor/save',
                title: this.$t('new'),
                img: '/img/no-image.svg',
                formHead: {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                },
                types: []
            }
        },
        validations: {
            model: {
                Name: { required },
                NameEng: { required },
                Address: { required },
                VatTin: {
                    required: requiredIf(function (model) {
                    return model.VendorTypeId != '34c61cfa-167d-4a4b-8934-6f55e6452a3f' ? true : false;
                    }),
                },
            }
        },
        created: async function () {
            let id = this.$route.params.id;
            if (id != undefined && id != null && id != '') {
                this.actionLink = 'vendor/update';
                await this.$api().post('vendor/find', { Id: id }).then(res => {
                    if (res.data != null) {
                        this.model = res.data.Data;
                        this.title = '[' + this.model.Name + ']';
                        if (this.model.Logo != null) {
                            this.img = this.$base() + 'image/logo/' + this.model.Logo;
                        }
                    }
                });
            }
            this.getTypes();
        },
        methods: {
            clickSaveHandler: function () {
                this.$v.$touch();
                if (!this.$v.$invalid) {
                    let loading = this.$loading.show();
                    let formData = new FormData();
                    // formData.append('File', this.$refs.file.files[0]);
                    for (let p in this.model) {
                        let val = this.model[p];
                        if (val != null)
                            formData.append(p, val);
                    }
                    formData.append('CompanyId', this.$store.state.company.Id);
                    formData.append('ClientId', this.$store.state.company.ClientId);

                    this.$api().post(this.actionLink, formData, this.formHead).then(res => {
                        if (this.$isValid(res)) {
                            this.$router.back();
                        }
                    }).finally(function () {
                        loading.hide();
                    });
                }
            },
            fileChangeHandler: function (e) {
                const file = e.target.files[0];
                this.img = URL.createObjectURL(file);
            },
            async getTypes() {
                let res = await this.$api().post('vendor/types');
                if (this.$isValid(res)) {
                    this.types = res.data.Json.Types;
                    if(this.types.length > 0 && this.model.VendorTypeId == null) {
                        this.model.VendorTypeId = this.types[0].Id;
                    }
                }
            }
        }
    };
</script>
